<template>
  <div class="row">
    <div class="col-12 px-0">
      <h1 class="d-flex align-items-center">
        <span class="icon icon-schliesszeiten mr-2" aria-hidden="true"></span>
        {{ $t('views.holidayList.title') }}
      </h1>
    </div>

    <link-back to="/" i18nMessage="common.backToDashboard" />

    <loading-container :state="state" errorLinkTo="/">

      <div class="d-flex justify-content-between justify-content-sm-start align-items-center btn-calendar mt-4">
        <h3 class="m-0 mr-2">{{ year }} </h3>

        <button @click.prevent="decrementYear()" class="btn btn-brand1">
          <span class="icon icon-navigation_pfeil_links" aria-hidden="true"></span>
          <span class="sr-only">{{ $t('views.holidayList.decrementYear') }}</span>
        </button>

        <button @click.prevent="incrementYear()" class="btn btn-brand1">
          <span class="icon icon-navigation_pfeil_rechts" aria-hidden="true"></span>
          <span class="sr-only">{{ $t('views.holidayList.incrementYear') }}</span>
        </button>
      </div>

      <div class="col-12 d-flex justify-content-end mt-2 mt-sm-0 px-0">
        <link-add-element i18nMessage="common.holiday.addIcal" to="/holiday-import" class="mr-3" />
        <link-add-element i18nMessage="common.holiday.add" to="/holiday-add" />
      </div>

      <ul v-if="holidays.length > 0" class="reports list-unstyled row mx-auto p-inline-start-0">
        <li v-for="(holiday, index) in holidays" :key="index" class="col-12 d-flex align-items-center">
          <div class="holiday-info">
            <span class="font-weight-bold mr-2">{{ holiday.date }}</span>
            {{ holiday.name }}
            {{ holiday.description }}
          </div>
          <div class="ml-auto d-flex align-items-center">
            <link-default i18nMessage="common.holiday.edit" :to="{ name: 'admin-holiday-edit', params: { id: holiday.id } }" :iconOnly="true" iconClass="icon-editieren" class="btn mr-2" />
            <button-delete @click.prevent="remove(holiday)" :iconOnly="true" class="no-btn-border" />
          </div>
        </li>
      </ul>
      <div v-if="!(holidays.length > 0)" class="teres-alert mt-3" role="alert">
        <feedback-message :message="$t('views.holidayList.noHolidays', { msg: year })" />
      </div>
    </loading-container>
  </div>
</template>

<script lang="ts">
import FeedbackMessage from '@/components/feedback/FeedbackMessage.vue';
import ButtonDelete from '@/components/interaction/ButtonDelete.vue';
import LinkAddElement from '@/components/interaction/LinkAddElement.vue';
import LinkDefault from '@/components/interaction/LinkDefault.vue';
import LoadingContainer from '@/components/structure/LoadingContainer.vue';
import { Holiday } from '@/generated/openapi';
import LoadingMixin from '@/mixins/LoadingMixin';
import { adminService } from '@/services/adminService';
import { now } from '@/utils/dateTimeUtils';
import { LoadingState } from '@/utils/loadingUtils';
import { defineComponent } from 'vue';
import LinkBack from '@/components/interaction/LinkBack.vue';
import { InfoPopupBase, InfoPopupType } from '@/models/InfoPopupData';

export default defineComponent({
  name: 'HolidayList',
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      year: now().year,
      holidays: [] as Holiday[]
    }
  },
  components: {
    LoadingContainer,
    FeedbackMessage,
    LinkAddElement,
    ButtonDelete,
    LinkDefault,
    LinkBack
  },
  created() {
    this.loadFromServer()
  },
  methods: {
    loadFromServer() {
      this.state = LoadingState.loading
      adminService.getHolidays(this.year)
        .then(result => {
          this.holidays = result.content || []
          this.state = LoadingState.success
        }).catch(this.handleError)
    },
    incrementYear() {
      this.year = this.year + 1;
      this.loadFromServer()
    },
    decrementYear() {
      this.year = this.year - 1;
      this.loadFromServer()
    },
    remove(holiday: Holiday) {
      this.state = LoadingState.loading
      adminService
        .deleteHoliday(holiday.id)
        .then(() => {
          this.$store.commit('addInfoPopup', {
            title: this.$t('views.holidayList.infopopup.delete'),
            type: InfoPopupType.info
          } as InfoPopupBase)
          this.loadFromServer()
        })
        .catch(this.handleError)
    }
  }
});
</script>
